import { useRef } from 'react'

interface Props {
  min: number
  max: number
  step?: number
  value: number
  onChange: (v: number) => void
  disabled?: boolean
  className?: string
}

export function Slider({ min, max, step = 1, value, onChange, disabled, className = '' }: Props) {
  const ref = useRef<HTMLInputElement>(null)
  const pct = max === min ? 0 : ((value - min) / (max - min)) * 100

  return (
    <div className={`relative flex items-center ${className}`} style={{ '--pct': `${pct}%` } as React.CSSProperties}>
      {/* Track */}
      <div className="absolute left-0 right-0 h-1 rounded-full bg-txt-meta/20 pointer-events-none">
        <div
          className="h-full rounded-full bg-accent transition-none"
          style={{ width: `${pct}%` }}
        />
      </div>
      <input
        ref={ref}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))}
        className={`w-full h-1 appearance-none bg-transparent cursor-pointer
          disabled:opacity-50 disabled:cursor-not-allowed
          [&::-webkit-slider-thumb]:appearance-none
          [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4
          [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white
          [&::-webkit-slider-thumb]:shadow-md [&::-webkit-slider-thumb]:border-0
          [&::-webkit-slider-thumb]:transition-transform
          [&::-webkit-slider-thumb]:hover:scale-110
          [&::-webkit-slider-thumb]:active:scale-125
          [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:h-4
          [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-white
          [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:shadow-md
          focus:outline-none`}
      />
    </div>
  )
}
